import actions from './actions';

const initState = {
  connected: false,
  items: []
};

export default function mqttReducer(state = initState, action) {
  // // console.log('ACTION_MQTT', action);
  switch (action.type) {
    // case action.SETTING_VIEW:
    //   return {
    //     ...state,
    //     view: action.view,
    //   };

    case actions.RECEIVED_NOTIFICATION:
      const notification = action.result;
      return {
        ...state,
        items: [notification, ...state.items]
      };
    default:
      return state;
  }
}
